
import RestaurantBookingSettingsCard from '@/components/restaurant/RestaurantBookingSettingsCard.vue';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-restaurant-booking',
  components: { RestaurantBookingSettingsCard },
})
export default class ProjectRestaurantBooking extends mixins(ProjectViewMixin) {}
